var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.6406L21.3984 0.875H29.4844L19.5469 17.7969L29.7422 35H21.5625L15 23.0469L8.4375 35H0.257812L10.4531 17.7969L0.515626 0.875H8.60156L15 12.6406Z",
    fill: "url(#paint0_linear_6_86)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_86",
    x1: 15,
    y1: 0.875,
    x2: 15,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.28e4caa87b06dad8fa96f59e63bb3772.svg";
export { ForwardRef as ReactComponent };